<script setup>
import { formatTelLink } from '@/composables/useFormatTelLink';
import ApplicationsList from '@/components/ApplicationsList.vue';
import SocialsList from '@/components/SocialsList.vue';
import FormConsultation from '@/components/forms/FormConsultation.vue';
defineProps({
  data: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <div v-if="data" class="footer__contacts">
    <p class="mb-0 footer__contacts-title h4" v-html="data.title"></p>
    <FormConsultation class="footer__contacts-form" />
    <div class="footer__contacts-info">
      <div
        v-if="data?.phone && data?.phone.length > 0"
        class="footer__contacts-phones"
      >
        <CIcon
          class="footer__contacts-phones-icon"
          name="phone-red"
          width="24"
          height="24"
        />
        <div class="footer__contacts-phones-list">
          <a
            v-for="phone in data?.phone"
            :key="phone"
            :href="`tel:${formatTelLink(data?.phone)}`"
            class="body-1-bold"
          >
            {{ phone }}</a
          >
        </div>
      </div>
      <SocialsList
        v-if="data?.messengers && data?.messengers.length > 0"
        :data="data?.messengers"
        :view="'light'"
        class="footer__contacts-messengers"
      />
    </div>
    <ApplicationsList
      v-if="data?.applications && data?.applications.length > 0"
      :data="data?.applications"
      :view="'light'"
      class="footer__contacts-applications"
      :buttons-prefix-class="'js-button-footer-application'"
    />
  </div>
</template>
<style scoped lang="scss">
.footer {
  &__contacts {
    align-items: start;
    background-color: $surface-container;
    border-radius: 4px;
    display: grid;
    gap: 32px;
    padding: 28px 16px 16px;
    grid-template-areas: 'title' 'form' 'info' 'applications';
    @include media-breakpoint-up(sm) {
      align-items: end;
      column-gap: 32px;
      grid-template-columns: 7fr 5fr;
      grid-template-areas: 'title title' 'form applications' 'info applications';
      padding: 32px;
      row-gap: 48px;
    }
    @include media-breakpoint-up(md) {
      align-items: start;
      grid-template-columns: 1fr;
      grid-template-areas: 'title' 'form' 'info' 'applications';
      padding: 32px 32px 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
      @include responsive-spacing(column-gap, 32);
      @include responsive-spacing(row-gap, 48);
      @include responsive-spacing(padding-bottom, 24);
      @include responsive-spacing(padding-left, 32);
      @include responsive-spacing(padding-right, 32);
      @include responsive-spacing(padding-top, 32);
    }
    &-title {
      grid-area: title;
    }
    &-form {
      grid-area: form;
      max-width: 324px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(max-width, 324);
      }
    }
    &-info {
      display: flex;
      flex-direction: column;
      gap: 24px;
      grid-area: info;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 24);
      }
    }
    &-phones {
      align-items: center;
      display: grid;
      gap: 16px;
      grid-template-columns: 24px auto;
      max-width: fit-content;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 16);
        grid-template-columns: px-to-vw(24) auto;
      }
      &-icon {
        height: 100%;
        width: 100%;
      }
      &-list {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(gap, 16);
        }
      }
    }
    &-applications {
      grid-area: applications;
      margin: 7px 0;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(margin-top, 7);
        @include responsive-spacing(margin-bottom, 7);
      }
    }
  }
}
</style>
